export const frontendEvents = {
  board: {
    ADD: 'board:add',
    DELETE: 'board:delete',
    SCROLL: 'board:scroll',
    CHANGE: 'board:change',
    CLEAR: 'board:clear',
    TITLE: 'board:title',
    REORDER: 'board:reorder'
  },
  draw: {
    START: 'draw:start',
    INTERMEDIATE: 'draw:intermediate',
    ELEMENT: 'draw:element',
    TEXT: 'draw:text',
    SELECT: 'draw:select',
    EDIT: 'draw:edit',
    UPDATE: 'draw:update',
    UNDO: 'draw:undo',
    REDO: 'draw:redo',
    DELETE: 'draw:delete',
    IMAGE: 'draw:image',
    INDEX: 'draw:index'
  },
  toolconfig: {
    TOOL: 'toolconfig:tool',
    COLOR: 'toolconfig:color',
    STROKE: 'toolconfig:stroke',
    FILL: 'toolconfig:fill',
    LASER: 'toolconfig:laser',
    CURSOR: 'draw:cursor'
  },
  background: {
    GRID: 'bg:grid',
    BACKGROUND: 'bg:background',
    PDF: 'bg:pdf'
  }
};

const socketEvents = {
  room: {
    START: 'room:start',
    STARTED: 'room:started',
    EXTEND: 'room:extend',
    SCREENSHARE_START: 'room:screen-share-start',
    SCREENSHARE_END: 'room:screen-share-end',
    BLOCK: 'block:state-update',
    FORCED_DISCONNECT: 'forcedDisconnect'
  },
  attendee: {
    JOIN: 'attendee:join',
    JOINED: 'attendee:joined',
    INITIALIZED: 'attendee:initialized',
    HAND_RAISE: 'hand:raise',
    REMOVE: 'attendee:remove',
    DISCONNECTED: 'attendee:disconnected',
    AUDIO: 'attendee:audio'
  },
  chat: {
    INIT: 'chat:init',
    INITIALIZED: 'chat:initialized',
    MESSAGE: 'attendee:message'
  },
  qna: {
    INIT: 'qna:init',
    INITIALIZED: 'qna:initialized',
    QUESTION: 'qna:question',
    UPVOTE: 'qna:upvote',
    ANSWERED: 'qna:answered'
  },
  board: {
    INIT: 'board:init',
    INITIALIZED: 'board:initialized',
    DRAW: 'board:draw'
  },
  class: {
    END: 'class:end',
    ENDED: 'class:ended'
  },
  poll: {
    LAUNCH: 'poll:launch',
    LAUNCHED: 'poll:launched',
    RESPONSE: 'poll:response',
    SAVE_RESPONSE: 'poll:save-response',
    END: 'poll:end',
    ENDED: 'poll:ended'
  }
};

export default socketEvents;
